<template>
  <div class="oran">
    <div class="oran-warp">
      <div class="csgo-top">
        <div class="left">幸运饰品</div>
        <div class="right">
          <span class="right-span right-span1" @click="goRule">活动规则</span>
          <span class="right-span right-span2" @click="goHistory">获得饰品历史</span>
        </div>
      </div>
      <div class="oran-sel">
        <div class="sel-top">
          <ul class="flex flex-w">
            <li v-for="(item,index) in selList" :key="item.id" @click="selOran(item)">
              <div class="seltop-warp" :class="{'seltop-warp1':searchForm.type_id==item.id}" @mouseenter="selMouseenter(item,'type_id')">
                <div class="img-box">
                  <img :src="item.img" />
                </div>
                <div class="p-1 name">{{ item.name }}</div>
              </div>
              <div v-if="item.subset.length>0" class="nav-justified-sort-detail" :class="{'nav-justified-sort-detail2':jisuan(index)}">
                <div class="nav-justified-sort-detail-left pull-right flex-0">
                  <img :src="subIMg" alt="" srcset="">
                </div>
                <div class="nav-justified-sort-detail-right pull-right">
                  <div class=" flex flex-w">
                    <div v-for="sub in item.subset" :key="sub.id" class="class-name p-1" @mouseenter="selMouseenter(sub,'subclass_id')" @click.stop="selSubclass(sub)">{{ sub.name }}</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="class-box">
          <!-- <div class="class-list">
            <ul>
              <li :class="{'class-active':searchForm.subclass_id==''}" @click="selSubclass({id:''})">全部</li>
              <li v-for="item in classList" :key="item.id" :class="{'class-active':item.id==searchForm.subclass_id}" @click="selSubclass(item)">{{ item.name }}</li>
            </ul>
          </div> -->
          <div class="sel-bot">
            <div class="selbot-right">
              <div class="sort-block flex flex-0 flex-ac" :class="{'sort-top':searchForm.sort=='asc','sort-bottom':searchForm.sort=='desc'}" @click="selPrice">
                <span class="span1">价格</span>
                <div class="sort-icon flex">
                  <i class="el-icon-caret-top"></i>
                  <i class="el-icon-caret-bottom"></i>
                </div>
              </div>
              <el-input placeholder="按名称搜索" v-model="searchForm.searchKey" class="input1" @change="getList">
                <i slot="suffix" class="el-input__icon el-icon-search input1-i"></i>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="oran-list">
        <div class="roll-list">
          <ul>
            <li v-for="item in list" :key="item.id" @click="goOrnamentOpen(item)">
              <div class="list-warp">
                <div :class="item.state ? 'list-bor' : ''"></div>
                <div class="list-img-box">
                  <span v-if="item.exteriorName" class="ico">{{ item.exteriorName }}</span>
                  <div class="list-img">
                    <img :src="item.imageUrl" />
                  </div>
                </div>
                <div class="bot-1">
                  <div class="list-name">{{ item.itemName }}</div>
                  <div class="list-pirce flex flex-jc">
                    <div class="pirce-left flex flex-ac">
                      <img src="@/assets/images/money.png" class="money-img" />
                      <span>{{ item.price }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="clear"></div>
        <empty v-if="list.length===0"></empty>
      </div>
    </div>
    <div class="clear"></div>
    <div class="csgo-page">
      <el-pagination background layout="prev, pager, next" :pager-count="5" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
      </el-pagination>
    </div>
    <myhomebot></myhomebot>
    <div class="commonBg"></div>
  </div>
</template>

<script>
import myhomebot from "@/components/my_homebot.vue";
import empty from "@/g-components/empty.vue";

export default {
  components: { myhomebot, empty },
  data() {
    return {
      list: [],
      classList: [],
      selList: [],
      listSlide: [],
      classObj: [{ name: "全部", flag: 0, skin_type_id: "", state: true }],
      classId: "1",
      subIMg: '',
      searchForm: {
        recommend: '',
        new: '',
        type_id: '',
        subclass_id: '',
        sort: 'desc',
        searchKey: '',
        page: 1,
        totalSize: 0,
        limit: 20
      },
      isMaxB: true
    };
  },
  mounted() {
    this.getListClass()
    this.getList()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth > 767) {
        this.isMaxB = true
      } else {
        this.isMaxB = false
      }
    },
    jisuan(index) {
      if (this.isMaxB) {
        if (index % 9 > 5) {
          return true
        } else {
          return false
        }
      } else {
        if (index % 4 > 1) {
          return true
        } else {
          return false
        }
      }
    },
    //分类
    getListClass() {
      this.$doGet("/api/hall.LuckySkin/types").then((res) => {
        this.selList = res.data
        // if (res.data.length) {
        //   this.searchForm.type_id = this.selList[0].id
        // }
      }).catch(() => { })
    },
    //默认推荐列表
    getList() {
      this.$doGet("/api/hall.LuckySkin/list", this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.list = res.data.list
      }).catch(() => { })
    },
    //分页
    currentChange(val) {
      this.searchForm.page = val
      this.getList(val);
    },
    //点击分类获取列表
    selOran(item) {
      if (this.searchForm.type_id == item.id) {
        this.searchForm.type_id = ''
      } else {
        this.searchForm.type_id = item.id
      }
      this.searchForm.subclass_id = ''
      this.getList()
    },
    selMouseenter(item, type) {
      if (type == 'type_id') {
        if (item.subset.length == 0) {
          return false
        }
        this.subIMg = item.subset[0].img
      } else {
        this.subIMg = item.img
      }
    },
    selSubclass(item) {
      if (this.searchForm.subclass_id == item.id) {
        return
      }
      this.searchForm.type_id = ''
      this.searchForm.subclass_id = item.id
      this.getList()
    },
    selPrice() {
      this.searchForm.sort = this.searchForm.sort ? this.searchForm.sort == 'asc' ? 'desc' : 'asc' : ''
      this.getList()
    },
    goOrnamentOpen(item) {
      this.$router.push({
        path: `/lucky/open`,
        query: {
          id: item.id,
        },
      });
    },
    //获得历史
    goHistory() {
      this.$router.push({
        path: `/lucky/history`,
      })
    },
    goRule() {
      this.$router.push({
        path: `/lucky/rule`,
      })
    }
  },
};
</script>

<style lang="less" scoped>
.oran {
  //padding-top: 20px;
  .oran-warp {
    max-width: 1500px;
    margin: 0 auto;
    background: rgba(26, 28, 32, 0.9);
    height: 100%;
    padding: 16px;
    .csgo-top {
      padding: 20px 0;
    }
  }
  .roll-list {
    margin-top: 20px;
    ul {
      margin: 0 -8px;
      li {
        width: 20%;
        float: left;
        .list-warp {
          margin: 8px;
          border-radius: 5px;
          position: relative;
          overflow: hidden;
          background: url('~@/assets/img/fight/item_bg.jpg') no-repeat;
          background-size: 100% 100%;
          text-align: center;
          border-radius: 5px;
          box-sizing: border-box;
          // border: 1px solid #fff;
          .list-bor {
            position: absolute;
            top: 0;
            z-index: 666;
            width: 100%;
            height: 100%;
            background-color: rgba(233, 177, 14, 0.1);
          }
          .list-img-box {
            padding-top: 15px;
            height: 100px;
            position: relative;
            overflow: hidden;
            margin-bottom: 15px;
            padding: 0px 20px 0;
            .ico {
              font-size: 12px;
              position: absolute;
              top: 0;
              left: 0;
              padding: 4px;
              color: #050505;
              background-color: #e6bd07;
              text-align: center;
            }
            .list-img {
              padding-top: 15px;
              img {
                width: auto;
                height: 85px;
              }
            }
          }
          .bot-1 {
            .list-name {
              padding: 0 5px;
              font-size: 12px;
              color: #fff;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .list-pirce {
              padding: 15px 5px;
              .pirce-left {
                img {
                  width: auto;
                  height: 15px;
                }
                span {
                  color: #e9b10e;
                  font-size: 12px;
                }
              }
            }
          }
          .rate {
            position: absolute;
            right: 10px;
            top: 10px;
            color: #fff;
          }
        }
      }
      li:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
